import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, isRef as _isRef, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "el-slider"
}
const _hoisted_2 = { class: "el-slider__runway is-disabled" }
const _hoisted_3 = { class: "el-slider__button el-tooltip__trigger el-tooltip__trigger" }

import {ISliderField} from "~/cabinet/vue/interface/form/elements/Interfaces";
import {
    FormElementExposeInterface,
    useFormElement,
    useFormElementProps
} from "~/cabinet/vue/interface/form/elements/useFormElement";
import {computed} from "vue";


const __default__ = {
    name: "SliderElement"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    ...useFormElementProps<ISliderField>()
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {

let props = __props;

let model = _useModel<any>(__props, "modelValue");

let formElement = useFormElement(model, props);

__expose<FormElementExposeInterface>(formElement.expose);

let readonlyValue = computed(() => {
    let min = props.field.min;
    let max = props.field.max;
    let value = model.value;
    return ((value - min) / ((max - min) / 100)).toFixed(0);
})

return (_ctx: any,_cache: any) => {
  const _component_el_slider = _resolveComponent("el-slider")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_ctx.readonly)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "el-slider__bar",
            style: _normalizeStyle({width: `${_unref(readonlyValue)}%`, left: 0})
          }, null, 4),
          _createElementVNode("div", {
            class: "el-slider__button-wrapper",
            role: "slider",
            style: _normalizeStyle({left: `${_unref(readonlyValue)}%`})
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
              [_directive_my_tooltip, _unref(readonlyValue)]
            ])
          ], 4)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_el_slider, {
        key: 1,
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : model = $event)),
        min: _ctx.field.min,
        max: _ctx.field.max,
        step: _ctx.field.step,
        disabled: _ctx.readonly
      }, null, 8, ["modelValue", "min", "max", "step", "disabled"]))
}
}

})